export default __webpack_public_path__ + "static/media/add-image.bdb723ca.svg";